import Segment from './Segment.styled'
export default Segment
